export default {
  BULLETIN: 'bulletin',
  GENERAL_DOCS: 'generalDocument',
  LEGAL_DOCS: 'legalDocument',
  OWNER_DOCS: 'ownerDocument',
  TO_EXPIRE_SLIPS: 'toExpirePaymentSlip',
  LATE_SLIPS: 'latePaymentSlip',
  ANTICIPATION_SLIPS: 'anticipationPaymentSlip',
  EVENT: 'event'
}


// WEBPACK FOOTER //
// ./src/utils/notificationTypes.js